export default __webpack_public_path__ + "3cd8400fefcd41fe460cb22248d2eac1.woff2";